import * as Yup from "yup";

const usernameRegex = new RegExp(/^[a-zA-Z0-9]*$/);
const answerRegex = new RegExp(/^[^;:*/?/&/{/}=/!#-]+$/);

export const usernameUpdateFormValidationSchema = Yup.object().shape({
  username: Yup.string()
    .required("Username can not be empty.")
    .matches(
      usernameRegex,
      "Cannot contain special characters or accented letters."
    )
    .test(
      "length",
      "Username must be between 5 to 30 characters long.",
      (username: string | undefined): boolean =>
        !!username &&
        username.trim().length >= 5 &&
        username.trim().length <= 30
    ),
});

export const emailUpdateFormValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Must be a valid email.")
    .required("Email can not be empty."),
  reEnteredEmail: Yup.string()
    .required("Re-entered email doesn't match.")
    .oneOf([Yup.ref("email")], "Re-entered email doesn't match."),
});

export const sqaFormValidationSchema = Yup.object().shape({
  securityQuestion: Yup.string().required(
    "Security Question must be selected."
  ),
  securityAnswer: Yup.string()
    .required("Security Answer can not be empty.")
    .test(
      "length",
      "Answer to your security question must be between 4 to 200 characters long.",
      (answer: string | undefined): boolean =>
        !!answer && answer.trim().length >= 4 && answer.trim().length <= 200
    )
    .matches(
      answerRegex,
      "Answer to your security question cannot contain the following characters: ; : * / ? & { } = ! # -."
    ),
});
